import React from 'react';
import { DollarSign, Users, TrendingUp, MapPin } from 'lucide-react';
import StatCard from './StatCard';

const AdminStatsGrid = ({ stats, sourcePageCount }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
    <StatCard icon={DollarSign} label="Seller Leads" value={stats?.totalSellerLeads ?? 0} tint="emerald" />
    <StatCard icon={Users} label="Buyer Leads" value={stats?.totalBuyerLeads ?? 0} tint="amber" />
    <StatCard icon={TrendingUp} label="Top Seller Source" value={stats?.sellerBySource?.[0]?.source || '—'} tint="emerald" />
    <StatCard icon={MapPin} label="Source Pages" value={sourcePageCount} tint="slate" />
  </div>
);

export default AdminStatsGrid;
